const a = {
  "pharma-card-content": "pharma-card-content",
  "pharma-card-content__label": "pharma-card-content__label",
  "pharma-card-content__value": "pharma-card-content__value"
};
export {
  a as default
};
